import { render, staticRenderFns } from "./editTable.vue?vue&type=template&id=fd5580d6&"
import script from "./editTable.vue?vue&type=script&lang=js&"
export * from "./editTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports